export default __webpack_public_path__ + "static/media/complementary--when-foggy--g1.ce7480ff.png";